export default "__VITE_ASSET__CV07Z77r__"